import React from 'react';

import SeparatorComponent from '../../separatorComponent/separatorComponent';
import SubTitleComponentV2 from '../subTitleComponentV2/subTitleComponentV2';
import TitleComponentV2 from '../titleComponentV2/titleComponentV2';

import './radioButtonComponent.css';

const RadioButtonComponent = ({
  isDisabled = false,
  isSelected = false,
  billingPlanFeature = null,
  titleTxt = null,
  toolTipPosition = 'right',
  toolTipTxt = null,
  subTitleTxt = null,
  onClick = () => {},
}) => {
  return (
    <div
      className={`et-v2-rbc-radio-button-container ${isDisabled ? 'et-v2-rbc-disabled' : ''}`}>
      <div
        className={`et-v2-rbc-circle ${isSelected ? 'et-v2-rbc-circle-selected' : ''}`}
        onClick={isDisabled ? null : onClick}>
        <div className="et-v2-rbc-inner-circle" />
      </div>
      <div className="et-v2-rbc-title-sub-title-wrap">
        <TitleComponentV2
          billingPlanFeature={billingPlanFeature}
          titleTxt={titleTxt}
          toolTipPosition={toolTipPosition}
          toolTipTxt={toolTipTxt}
        />
        <SeparatorComponent isSmall />
        <SubTitleComponentV2 subTitleTxt={subTitleTxt} />
      </div>
    </div>
  );
};

export default RadioButtonComponent;
